// src/api/metricas.js - VERSIÓN CORREGIDA Y MANTENIENDO TU ESTRUCTURA
import { authFetch } from './interceptors';
import { 
  getExportUrl,  
  API_ENDPOINTS  
} from '../utils/url';

const API_PREFIX = '/api/minutes/v1';

export const metricasService = {
  // Métricas básicas (funcionan)
  getMetricasEmpresas: async (filters = {}) => {
    const params = new URLSearchParams();
    Object.keys(filters).forEach(key => {
      if (filters[key] && String(filters[key]).trim() !== '') {
        params.append(key, filters[key]);
      }
    });
    
    const url = `${API_PREFIX}/metricas/empresas/`;
    console.log('desde metricas jsssss', url)
    const response = await authFetch(params.toString() ? `${url}?${params.toString()}` : url);
    
    return {
      metricas: response.data || [],
      resumen: response.resumen || {}
    };
  },

  getMetricasContadores: async (filters = {}) => {
    const params = new URLSearchParams();
    Object.keys(filters).forEach(key => {
      if (filters[key] && String(filters[key]).trim() !== '') {
        params.append(key, filters[key]);
      }
    });
    
    const url = `${API_PREFIX}/metricas/contadores/`;
    const response = await authFetch(params.toString() ? `${url}?${params.toString()}` : url);
    
    return {
      metricas: response.data || [],
      resumen: response.resumen || {}
    };
  },

  // Métricas detalladas (funcionan) - ¡ESTAS SON LAS QUE NECESITAS!
  getMetricasEmpresasDetalladas: async (filters = {}) => {
    const params = new URLSearchParams();
    Object.keys(filters).forEach(key => {
      if (filters[key] && String(filters[key]).trim() !== '') {
        params.append(key, filters[key]);
      }
    });
    
    const url = `${API_PREFIX}/metricas/empresas/detalladas/`;
    const response = await authFetch(params.toString() ? `${url}?${params.toString()}` : url);
    
    return {
      metricas: response.data || [],
      resumen: response.resumen || {}
    };
  },

  getMetricasContadoresDetalladas: async (filters = {}) => {
    const params = new URLSearchParams();
    Object.keys(filters).forEach(key => {
      if (filters[key] && String(filters[key]).trim() !== '') {
        params.append(key, filters[key]);
      }
    });
    
    const url = `${API_PREFIX}/metricas/contadores/detalladas/`;
    const response = await authFetch(params.toString() ? `${url}?${params.toString()}` : url);
    
    return {
      metricas: response.data || [],
      resumen: response.resumen || {}
    };
  },

  // 🔥 NUEVAS FUNCIONES DE EXPORTACIÓN
  exportActasCompletasExcel: async (filters = {}) => {
    try {
      //console.log('📤 Exportando actas completas con filtros:', filters);
      
      const params = new URLSearchParams(filters).toString();
      const url = `/api/minutes/v1/export/actas/completas/excel/${params ? `?${params}` : ''}`;
      
      //console.log('🌐 URL de exportación completa:', url);
      return await authFetch(url);
    } catch (error) {
      //console.error('❌ Error exportando actas completas:', error);
      throw error;
    }
  },

  exportMetricasProfesionalExcel: async (profesionalUsername, filters = {}) => {
    try {
      //console.log('📤 Exportando profesional desde Django:', {
      //  profesionalUsername,
      //  filters
      //});
      
      const params = new URLSearchParams(filters).toString();
      const url = `/api/minutes/v1/export/metricas/profesional/${profesionalUsername}/excel/${params ? `?${params}` : ''}`;
      
      //console.log('🌐 URL de exportación profesional:', url);
      return await authFetch(url);
    } catch (error) {
      //console.error('❌ Error exportando profesional:', error);
      throw error;
    }
  },

  exportMetricasEmpresaExcel: async (empresaNombre, filters = {}) => {
    try {
      console.log('📤 Exportando empresa desde Djangooooooooooo:', {
        empresaNombre,
        filters
      });
      const empresaEncoded = encodeURIComponent(empresaNombre);
      const params = new URLSearchParams(filters).toString();
      const url = `/api/minutes/v1/export/metricas/empresa/${empresaEncoded}/excel/${params ? `?${params}` : ''}`;
      console.log('🌐 URL de exportación empresa:', url);
      return await authFetch(url);
    } catch (error) {
      //console.error('❌ Error exportando empresa:', error);
      throw error;
    }
  },

  // Exportaciones existentes (mantener compatibilidad)
  exportMetricasEmpresasExcel: async (filters = {}) => {
    try {
      //console.log('📤 Exportando empresas desde Django con filtros:', filters);
      const exportUrl = getExportUrl('empresas', filters);
      console.log('🌐 URL de exportación:', exportUrl);
      
      return await authFetch(exportUrl);
    } catch (error) {
      //console.error('❌ Error exportando empresas desde Django:', error);
      throw error;
    }
  },

  exportMetricasContadoresExcel: async (filters = {}) => {
    try {
      //console.log('📤 Exportando contadores desde Django con filtros:', filters);
      
      const exportUrl = getExportUrl('contadores', filters);
      //console.log('🌐 URL de exportación:', exportUrl);
      
      return await authFetch(exportUrl);
    } catch (error) {
      //console.error('❌ Error exportando contadores desde Django:', error);
      throw error;
    }
  },

  exportMetricasCompletoExcel: async (filters = {}) => {
    try {
      //console.log('📤 Exportando métricas completas desde Django con filtros:', filters);
      
      const exportUrl = getExportUrl('completo', filters);
      //console.log('🌐 URL de exportación:', exportUrl);
      
      return await authFetch(exportUrl);
    } catch (error) {
      //console.error('❌ Error exportando métricas completas desde Django:', error);
      throw error;
    }
  },

  // Obtener datos para filtros
  getEmpresasParaFiltro: async () => {
    try {
      const response = await authFetch(API_ENDPOINTS.EMPRESAS_LIST);
      
      if (response && Array.isArray(response)) {
        return response;
      }
      if (response && response.data) {
        return response.data;
      }
      if (response && response.success && response.data) {
        return response.data;
      }
      
      //console.warn('Formato de respuesta inesperado:', response);
      return [];
    } catch (error) {
      //console.warn('No se pudo cargar lista de empresas:', error.message);
      return [];
    }
  },

  getContadoresParaFiltro: async () => {
    try {
      const response = await authFetch(`${API_ENDPOINTS.USUARIOS_LIST}users/`);
      
      if (response && Array.isArray(response)) {
        return response;
      }
      if (response && response.data) {
        return response.data;
      }
      if (response && response.success && response.data) {
        return response.data;
      }
      
      //console.warn('Formato de respuesta inesperado:', response);
      return [];
    } catch (error) {
      //console.warn('No se pudo cargar lista de contadores:', error.message);
      return [];
    }
  }
};
